import * as z from "zod";

export const CustomerPortalBundlesFlatTeamSettingsSchema = z.object({
  bundles: z.array(z.unknown()).nullish(),
});
